var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h6',[_c('span',{staticClass:"custom-badge text-capitalize",class:_vm.badgeClass},[(_vm.badgeIcon)?_c('i',{staticClass:"me-1",class:_vm.badgeIcon}):_vm._e(),_vm._v("\n    "+_vm._s(_vm.status)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }